module.exports = __webpack_public_path__ + "img/3722499.6318b570.jpg";